import { render, staticRenderFns } from "./repjob.vue?vue&type=template&id=67b2db96&"
import script from "./repjob.vue?vue&type=script&lang=js&"
export * from "./repjob.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports